import React, { Component } from 'react';
import { Form, Input, Tabs, message, Select, DatePicker, Button, Radio,Modal,Row,Tree  } from 'antd';
import axios from 'axios';
import API from '../../../../API/api';

import { SUBJECT } from '../../../../utils/questionManageType';

import moment from 'moment';
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;
const TreeNode = Tree.TreeNode;
class CreateTask extends Component{
    state = {
        loading: false,
        visible: false,
        editionList:[],
        bookList:[],
        paperList:[],
        entrytaskKnowledgeList:[],
        subject:'',
        gradepart:'',
        edition:'',
        book:'',
        assistList:[],
        assist:'',
        section:'',
        tab:1,
        paper:'',
        inputEndTime:moment.now(),
        checkEndTime:'',
        resourceUrl:'',
        resourceType:'',
        subjectType:'',
        questionType:'1',
        mark:'',
        checkedKeys:[],
        entrytaskKnowledgeCheckedKeys:[],
    }
    componentDidMount(){
        if(this.props.taskId){
            axios.post(API.GET_TASK_DETAIL,{task_id:this.props.taskId}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                		let checkedKeys=[res.data.relate_id]
                    this.setState({name:res.data.name,
                        subject:res.data.subject,
                        gradepart:res.data.gradepart,
                        check_dead_time:res.data.check_dead_time,
                        entry_dead_time:res.data.entry_dead_time,
                        resourceType:res.data.resource_type,
                        subjectType:res.data.subject_type,
                        edition:res.data.ext.edition.edition_id,
                        book:res.data.ext.book.book_id,
                        assist:res.data.ext.assist.assist_id,
                        section:res.data.ext.section.section_id,
                        mark:res.data.mark,
                        resourceUrl:res.data.resource_url,
                        defaultExpandAll:true,
                        checkedKeys
                    })
                    axios.post(API.GET_EDITION,{subject:this.state.subject,gradepart:this.state.gradepart}).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({editionList:res.data});
                        }else{
                            message.error(res.message);
                        }
                    },(error)=>{
                        message.error('网络错误！');
                    });
                    axios.post(API.GET_BOOK,{subject:this.state.subject,gradepart:this.state.gradepart,editionId:this.state.edition}).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({bookList:res.data});
                        }else{
                            message.error(res.message);
                        }
                    },(error)=>{
                        message.error('网络错误！');
                    });
                    axios.post(API.GET_ASSIST,{bookId:this.state.book}).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({assistList:res.data});
                        }else{
                            message.error(res.message);
                        }
                    },(error)=>{
                        message.error('网络错误！');
                    });
                    axios.post(API.GET_SECTION,{assistId:this.state.assist}).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({sectionList:res.data});
                        }else{
                            message.error(res.message);
                        }
                    },(error)=>{
                        message.error('网络错误！');
                    });
                }else{
                    message.error(res.message);
                }
            },(error)=>{
                message.error('网络错误！');
            });
        }
        else{
            this.setState({
                subject:this.props.user.subject,
                gradepart:this.props.user.grade_part,})
            this.getEdition()
            this.getPaper()
            this.getAlbum()
            this.getEntrytaskKnowledge()
        }

    }
    loopSection = (data, checkedKeys, callback) => {
        data.forEach((item, index, arr) => {
            let flag = checkedKeys.some(d=>d==item.id)
            if (item.list) {
                return this.loopSection(item.list, checkedKeys, callback);
            }else{
                if (flag) {
                    return callback(item, index, arr);
                }
            }

        });
    };
    onOk=()=>{
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({ loading: true });
                let source_id = []
                if(this.state.sectionList&&this.state.sectionList.length){
                    this.loopSection(this.state.sectionList, this.state.checkedKeys, (item, index, arr)=>{
                        source_id.push(item.id)
                    })
                }

                let data = {};

                data.check_dead_time = values.check_dead_time.format('YYYY-MM-DD');
                data.entry_dead_time = values.entry_dead_time.format('YYYY-MM-DD');
                data.gradepart = values.gradepart;
                data.name = values.name;
                data.resource_type = values.resource_type;
                data.resource_url = values.resource_url?values.resource_url:'';
                data.subject = values.subject;
                data.subject_type = values.subject_type;
                data.mark = values.mark;
                if(this.props.taskId){
                    data.task_id = this.props.taskId
                }
                if(this.state.tab == 1)
                {
                    if(!(this.state.checkedKeys.length>0))
                    {
                        values.source_type=11;
                        source_id=this.state.assist;
                    }
                    else{
                        values.source_type=1;
                        if(!this.state.createTaskCount){
                            if(this.props.taskId){
                                if(source_id.length){
                                    source_id=source_id[0]
                                }else{
                                    return message.error('请选择一个章节')
                                }
                            }else{
                                this.setState({createTaskCount:source_id.length})
                                return
                            }
                        }else{
                            this.setState({createTaskCount:false})
                        }

                    }
                    values.subject=this.state.subject;
                    values.gradepart=this.state.gradepart;
                    data.source_id = source_id;
                    data.source_type = values.source_type;
                }
                else if(this.state.tab == 3){//创建专辑任务
                    values.source_type=3;//专辑
                    data.source_id = this.state.album;
                    data.source_type = values.source_type;
                }
                else if(this.state.tab == 4){//创建口算知识点任务
                    values.source_type=4;//专辑

                    if(this.state.entrytaskKnowledgeCheckedKeys.length){
                        data.source_id = this.state.entrytaskKnowledgeCheckedKeys;
                        if(!this.state.createTaskCountKonw){
                                this.setState({createTaskCountKonw:data.source_id.length})
                                return
                        } else{
                            this.setState({createTaskCountKonw:false})
                        }
                    }else{
                        return message.error('请选择一个知识点')
                    }
                    data.source_type = values.source_type;
                }
                else{
                    values.source_type=2;
                    data.source_id = this.state.paper;
                    data.source_type = values.source_type;
                }
                if(this.props.taskId){
                    axios.post(API.EDIT_TASK,data).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            message.success('任务修改成功');
                            this.setState({ loading: false, visible:false});
                            this.props.refresh();
                            this.props.onCancel();
                        }else{
                            message.error(res.message);
                            this.setState({ loading: false});
                        }
                    },(error)=>{
                        message.error('网络错误！');
                    });
                }else{
                    axios.post(API.ADD_TASK,data).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            message.success('任务创建成功');
                            this.setState({ loading: false, visible:false});
                            this.props.refresh(1);
                            this.props.onCancel();
                        }else{
                            message.error(res.message);
                            this.setState({ loading: false});
                        }
                    },(error)=>{
                        message.error('网络错误！');
                    });
                }
            }

        });
    }

    getEdition = () => {
            axios.post(API.GET_EDITION,{subject:this.state.subject||this.props.user.subject,gradepart:this.state.gradepart||this.props.user.grade_part}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({editionList:res.data,
                                    edition:'',
                                    book:'',
                                    assist:'',
                                    section:'',
                                    paper:''
                                });
                    this.props.form.setFieldsValue({editionId:undefined,book:undefined,assist:undefined,section:undefined});
                }else{
                    message.error(res.message);
                }
            },(error)=>{
                message.error('网络错误！');
            });
    }
    getPaper = ()=>{
        axios.post(API.GET_PAPER,{subject:this.state.subject||this.props.user.subject,gradepart:this.state.gradepart||this.props.user.grade_part}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({paperList:res.data,
                    edition:'',
                    book:'',
                    assist:'',
                    section:'',
                    paper:''});
                this.props.form.setFieldsValue({editionId:undefined,book:undefined,assist:undefined,section:undefined});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    getAlbum = ()=>{
        let subject = this.state.subject||this.props.user.subject
        if(subject!==SUBJECT.ENGLISH){return}
        axios.post(API.ALBUM_PAFGE_ALL_LIST).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({albumList:res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }

    getEntrytaskKnowledge = ()=>{//获取口算知识点树  用于手动泛化
        let subject = this.state.subject||this.props.user.subject
        if(subject!==SUBJECT.MATH){return}
        axios.post(API.ENTRY_TASH_KNOWLEDGE,{subject,gradepart:this.state.gradepart||this.props.user.grade_part}).then((res)=>{
            res = res.data
            if (res.code === 0) {

                this.setState({entrytaskKnowledgeList:res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    onPaperChange = (val) => {
        this.setState({paper:val,});
    }
    onAlbumChange = (val) => {
        this.setState({album:val,});
    }
    onEditionChange = (val) => {
        if(this.state.subject != '' && this.state.gradepart != '' && val != this.state.edition){
            axios.post(API.GET_BOOK,{subject:this.state.subject,gradepart:this.state.gradepart,editionId:val}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({bookList:res.data,edition:val, book:'', assist:'', section:'',checkedKeys:[]});
                    this.props.form.setFieldsValue({book:undefined,assist:undefined,section:undefined});
                }else{
                    message.error(res.message);
                }
            },(error)=>{
                message.error('网络错误！');
            });
        }
    }
    onBookChange = (val) => {
        if(val != this.state.book){
            axios.post(API.GET_ASSIST,{bookId:val}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({assistList:res.data,book:val, assist:'', section:'',checkedKeys:[]});
                    this.props.form.setFieldsValue({assist:undefined,section:undefined});
                }else{
                    message.error(res.message);
                }
            },(error)=>{
                message.error('网络错误！');
            });
        }
    }
    onAssistChange = (val)=> {
        if(val != this.state.assist){
            axios.post(API.GET_SECTION,{assistId:val}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({sectionList:res.data,assist:val, section:'',checkedKeys:[]});
                    this.props.form.setFieldsValue({section:undefined});
                }else{
                    message.error(res.message);
                }
            },(error)=>{
                message.error('网络错误！');
            });
        }
    }
    onSectionChange = (val) => {
        this.setState({section:val});
    }
    onTabChange = (key) => {
        this.setState({tab:key})

    }
    onSetInputEndTime = (val) => {
        this.setState({inputEndTime:val.unix(Number)})
    }
    onSetCheckEndTime = (val) => {
        this.setState({checkEndTime:val.unix(Number)})
    }
    onQuestionTypeChange = (val) => {
        this.setState({questionType:val})
    }
    
    checkedSections=(checkedKeys)=>{
    		if(this.props.task_id){
    			checkedKeys=checkedKeys.slice(0,1)
    		}
    		this.setState({checkedKeys})
    }

    render(){
        const {visible, user } = this.props;
        const { subject } = user;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const dateItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 10 },
            },
        };
        let inputDisabledDate = (current)=>{
            return current && current.valueOf() < Date.now() - 86400000;
        }
        let checkDisabledDate = (current)=>{
            return current && current.valueOf() < moment.unix(this.state.inputEndTime);
        }

        const loop = data => data.map((item) => {
            if (item.list) {
                return (
                    <TreeNode key={ item.id }  title = {item.name}>
                        {loop(item.list)}
                    </TreeNode>
                );
            }
            return <TreeNode key={ item.id } title = {subject === SUBJECT.CHINESE ? `${item.name}(${item.id})` : item.name} />;
        });

        
        return(
            <div>
                <Modal
                    visible={visible}
                    title={this.props.taskId?"修改任务":"新建任务"}
                    onOk={this.onOk}
                    onCancel={this.props.onCancel}
                    footer={[
                        <Button key="back" size="large" onClick={this.props.onCancel}>取消</Button>,
                        <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.onOk}>
                            {this.props.taskId?"修改任务":"创建任务"}
                        </Button>,
                    ]}
                >
                    <Form>
                        <FormItem
                            {...formItemLayout}
                            label="任务名称"
                            hasFeedback
                            style={{marginBottom:10}}
                        >
                            {getFieldDecorator('name', {
                                initialValue:this.state.name,
                                rules: [{
                                    type: 'string', message: '请输入正确的任务名称',
                                }, {
                                    required: true, message: '请输入任务名称',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="文档地址"
                            hasFeedback
                            style={{marginBottom:10}}
                        >
                            {getFieldDecorator('resource_url', {
                                initialValue:this.state.resourceUrl,
                                rules: [{
                                    type: 'url', message: '请输入正确的URL',
                                }, {
                                    required: false, message: '请输入资源地址',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="题库类型" style={{marginBottom:10}}>
                            {getFieldDecorator('source_id', {
                                    initialValue:"1",
                                    rules:[{
                                        required: true, message: '请选择题库类型',
                                    }],
                                })(<div style={{display:"none"}}><Input /></div>)
                            }
                            <Tabs onChange={this.onTabChange} defaultActiveKey={"1"}>
                                <TabPane tab="章节" key="1">

                                    <FormItem style={{marginBottom:10,width:210,display:'inline-block'}} hasFeedback>
                                        {getFieldDecorator('editionId', {
                                                initialValue:this.state.edition?this.state.edition:undefined,
                                                rules:[{
                                                    required: this.state.tab == 1?true:false, message: '请选择教材',
                                                }],
                                            })(<Select onSelect={this.onEditionChange} placeholder="选择教材">
                                                    {
                                                        this.state.editionList && this.state.editionList.map(item =>
                                                            <Option key={item.edition_id}  value={item.edition_id.toString()}>{item.name}</Option>
                                                        )
                                                    }
                                                </Select>)
                                        }
                                    </FormItem>
                                    <FormItem style={{marginBottom:10,width:210,display:'inline-block'}} hasFeedback>
                                        {getFieldDecorator('book', {
                                            initialValue:this.state.book?this.state.book:undefined,
                                            rules:[{
                                                required: this.state.tab == 1?true:false, message: '请选择课本',
                                            }],
                                        })(<Select onSelect={this.onBookChange} placeholder="选择课本">
                                                {
                                                    this.state.bookList && this.state.bookList.map(item =>
                                                        <Option key={item.book_id}  value={item.book_id.toString()}>{item.name}</Option>
                                                    )
                                                }
                                            </Select>)
                                            }
                                    </FormItem>
                                    <FormItem style={{marginBottom:10,width:210,display:'inline-block'}} hasFeedback>
                                        {getFieldDecorator('assist', {
                                            initialValue:this.state.assist?this.state.assist:undefined,
                                            rules:[{
                                                required: this.state.tab == 1?true:false, message: '请选择教辅',
                                            }],
                                        })(<Select onSelect={this.onAssistChange} placeholder="选择教辅">
                                                {
                                                    this.state.assistList && this.state.assistList.map(item =>
                                                        <Option key={item.assist_id}  value={item.assist_id.toString()}>{item.name}</Option>
                                                    )
                                                }
                                            </Select>)
                                            }
                                    </FormItem>

                                    	<Row>
                                        <Tree
                                            onCheck={this.checkedSections}
                                            checkable
                                            checkedKeys={[...this.state.checkedKeys]}
                                            defaultExpandAll={this.state.defaultExpandAll}
                                        >
                                            {loop(this.state.sectionList || [])}
                                        </Tree>
                                    </Row>
                                </TabPane>
                                <TabPane tab="试卷" key="2">

                                    <FormItem style={{marginBottom:10,width:210,display:'inline-block'}} hasFeedback>
                                        {getFieldDecorator('paperId', {
                                            initialValue:this.state.paper,
                                            rules:[{
                                                required: this.state.tab == 2?true:false, message: '请选择试卷',
                                            }],
                                        })(<Select onSelect={this.onPaperChange} placeholder="选择试卷">
                                            {
                                                this.state.paperList && this.state.paperList.map(item =>
                                                    <Option key={item.paper_id}  value={item.paper_id.toString()}>{item.name}</Option>
                                                )
                                            }
                                        </Select>)
                                        }
                                    </FormItem>
                                </TabPane>
                                {
                                    this.props.user.subject===SUBJECT.ENGLISH&&
                                    <TabPane tab="专辑" key="3">

                                        <FormItem style={{marginBottom:10,width:210,display:'inline-block'}} hasFeedback>
                                            {getFieldDecorator('paperId', {
                                                initialValue:this.state.album,
                                                rules:[{
                                                    required: this.state.tab == 2?true:false, message: '请选择专辑',
                                                }],
                                            })(<Select onSelect={this.onAlbumChange} placeholder="选择专辑">
                                                {
                                                    this.state.albumList && this.state.albumList.map(item =>
                                                        <Option key={item.album_id}  value={item.album_id.toString()}>{item.name}</Option>
                                                    )
                                                }
                                            </Select>)
                                            }
                                        </FormItem>
                                    </TabPane>
                                }
                                {
                                    this.props.user.subject===SUBJECT.MATH&&
                                    <TabPane tab="口算" key="4">


                                        <Row>
                                            <Tree
                                                onCheck={(entrytaskKnowledgeCheckedKeys)=>{if(this.props.task_id){entrytaskKnowledgeCheckedKeys=entrytaskKnowledgeCheckedKeys.slice(0,1)};this.setState({entrytaskKnowledgeCheckedKeys})}}
                                                checkable
                                                checkedKeys={this.state.entrytaskKnowledgeCheckedKeys}
                                                defaultExpandAll={this.state.defaultExpandAll}
                                            >
                                                {loop(this.state.entrytaskKnowledgeList || [])}
                                            </Tree>
                                        </Row>
                                    </TabPane>
                                }


                            </Tabs>
                        </FormItem>
                        <FormItem {...dateItemLayout} label="学科类型" hasFeedback style={{marginBottom:10}}>
                            {getFieldDecorator('subject_type', {
                                initialValue:this.state.subjectType,
                                rules:[{
                                    required: true, message: '请选择学科类型',
                                }],
                            })(
                                <Radio.Group>
                                    <Radio value="1">文科</Radio>
                                    <Radio value="2">理科</Radio>
                                </Radio.Group>)
                            }
                        </FormItem>
                        <FormItem {...dateItemLayout} label="资源类型" hasFeedback style={{marginBottom:10}}>
                            {getFieldDecorator('resource_type', {
                                initialValue:this.state.resourceType,
                                rules:[{
                                    required: true, message: '请选择资源类型',
                                }],
                            })(<Radio.Group>
                                <Radio value="1">电子</Radio>
                                <Radio value="2">纸质</Radio>
                                <Radio value="3">原创</Radio>
                            </Radio.Group>)
                            }
                        </FormItem>
                        <FormItem {...dateItemLayout} label="题目类型" style={{marginBottom:10}}>
                            {getFieldDecorator('question_type', {
                                initialValue:this.state.questionType,
                                rules:[{
                                    required: false, message: '请选择题目类型',
                                }],
                            })(<Select onSelect={(val)=>this.onQuestionTypeChange(val,'1')} placeholder="选择题目类型" disabled>
                                <Option key={1} value={'1'}>口算</Option>
                                <Option key={2} value={'2'}>基础训练</Option>
                                <Option key={2} value={'3'}>应用题</Option>
                            </Select>)
                            }

                        </FormItem>
                        <FormItem {...dateItemLayout} label="录入截止时间" hasFeedback style={{marginBottom:10}}>
                            {getFieldDecorator('entry_dead_time', {
                                initialValue:this.state.entry_dead_time && moment(this.state.entry_dead_time, 'YYYY-MM-DD'),
                                rules:[{
                                    required: true, message: '请选择录入截止时间',
                                }],
                            })(<DatePicker
                                    format="YYYY-MM-DD"
                                    placeholder={'录入截止时间'}
                                    onChange={this.onSetInputEndTime}
                                    allowClear={false}
                                    disabledDate={inputDisabledDate}
                                />)
                            }
                        </FormItem>
                        <FormItem {...dateItemLayout} label="审核截止时间" hasFeedback style={{marginBottom:10}}>
                            {getFieldDecorator('check_dead_time', {
                                initialValue:this.state.check_dead_time && moment(this.state.check_dead_time, 'YYYY-MM-DD'),
                                rules:[{
                                    required: true, message: '请选择审核截止时间',
                                }],
                            })(<DatePicker
                                    format="YYYY-MM-DD"
                                    placeholder={'审核截止时间'}
                                    onChange={this.onSetCheckEndTime}
                                    allowClear={false}
                                    disabledDate={checkDisabledDate}
                                />)
                            }
                        </FormItem>
                        <FormItem {...formItemLayout} label="备注" hasFeedback>
                            {
                                getFieldDecorator('mark',{ initialValue: this.state.mark })(<Input />)
                            }
                        </FormItem>
                    </Form>
                </Modal>
                <Modal
                    visible={!!this.state.createTaskCount}
                    title={"确认创建"}
                    onOk={this.onOk}
                    onCancel={()=>{this.setState({createTaskCount:false,loading:false})}}
                >
                    <span>您已选择{this.state.createTaskCount}个章节，确 定创建对应任务吗?</span>

                </Modal>
                <Modal
                    visible={!!this.state.createTaskCountKonw}
                    title={"确认创建"}
                    onOk={this.onOk}
                    onCancel={()=>{this.setState({createTaskCountKonw:false,loading:false})}}
                >
                    <span>您已选择{this.state.createTaskCountKonw}个知识点，确 定创建对应任务吗?</span>

                </Modal>
            </div>
        );
    }

}
const WrappedCreateTaskForm = Form.create()(CreateTask);
export default WrappedCreateTaskForm


// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_list/creat_task/view.js